import { fetcher_default } from "./chunk-GONJSORR.mjs";
import { __export } from "./chunk-QK4PKNB3.mjs"; // src/services/factory.ts

var factory_exports = {};

__export(factory_exports, {
  cancelReserveClasses: function cancelReserveClasses() {
    return _cancelReserveClasses;
  },
  getCoachList: function getCoachList() {
    return _getCoachList;
  },
  getFactoryClientInfo: function getFactoryClientInfo() {
    return _getFactoryClientInfo;
  },
  getFactoryCourse: function getFactoryCourse() {
    return _getFactoryCourse;
  },
  getFactoryList: function getFactoryList() {
    return _getFactoryList;
  },
  getReserveClasses: function getReserveClasses() {
    return _getReserveClasses;
  },
  query_member_contract_info: function query_member_contract_info() {
    return _query_member_contract_info;
  },
  query_member_info: function query_member_info() {
    return _query_member_info;
  },
  reserveClasses: function reserveClasses() {
    return _reserveClasses;
  },
  verifyMemberInfo: function verifyMemberInfo() {
    return _verifyMemberInfo;
  }
});

var _getFactoryList = function _getFactoryList() {
  return fetcher_default.get("/v4/fitness_factory/branch_information");
};

var _getFactoryCourse = function _getFactoryCourse(_ref) {
  var branch_code = _ref.branchCode,
      date = _ref.date;
  return fetcher_default.get("/v4/fitness_factory/class_schedules", {
    branch_code: branch_code,
    date: date
  });
};

var _getCoachList = function _getCoachList(_ref2) {
  var branch_code = _ref2.branchCode;
  return fetcher_default.get("/v4/fitness_factory/coach_information", {
    branch_code: branch_code
  });
};

var _getFactoryClientInfo = function _getFactoryClientInfo(_ref3) {
  var member_code = _ref3.member_code;
  return fetcher_default.get("/v4/fitness_factory/client_membership_information", {
    member_code: member_code
  });
};

var _getReserveClasses = function _getReserveClasses(_ref4) {
  var member_code = _ref4.member_code,
      start_date = _ref4.start_date,
      end_date = _ref4.end_date;
  return fetcher_default.get("/v4/fitness_factory/get_classes_by_member_code", {
    member_code: member_code,
    start_date: start_date,
    end_date: end_date
  });
};

var _reserveClasses = function _reserveClasses(_ref5) {
  var member_code = _ref5.member_code,
      coach_class_id = _ref5.coach_class_id;
  return fetcher_default.get("/v4/fitness_factory/make_appointment", {
    member_code: member_code,
    coach_class_id: coach_class_id
  });
};

var _cancelReserveClasses = function _cancelReserveClasses(_ref6) {
  var member_code = _ref6.member_code,
      coach_class_id = _ref6.coach_class_id;
  return fetcher_default.get("/v4/fitness_factory/cancel_appointment ", {
    member_code: member_code,
    coach_class_id: coach_class_id
  });
};

var _verifyMemberInfo = function _verifyMemberInfo(_ref7) {
  var identity_number = _ref7.identity_number;
  return fetcher_default.get("/v4/fitness_factory/verify_member_info", {
    type: 1,
    certificates_code: identity_number
  });
};

var _query_member_info = function _query_member_info(_ref8) {
  var member_code = _ref8.member_code;
  return fetcher_default.get("/v4/fitness_factory/query_member_info", {
    member_code: member_code
  });
};

var _query_member_contract_info = function _query_member_contract_info(_ref9) {
  var member_code = _ref9.member_code,
      type = _ref9.type;
  return fetcher_default.get("/v4/fitness_factory/query_member_contract_info", {
    member_code: member_code,
    type: type
  });
};

export { _getFactoryList as getFactoryList, _getFactoryCourse as getFactoryCourse, _getCoachList as getCoachList, _getFactoryClientInfo as getFactoryClientInfo, _getReserveClasses as getReserveClasses, _reserveClasses as reserveClasses, _cancelReserveClasses as cancelReserveClasses, _verifyMemberInfo as verifyMemberInfo, _query_member_info as query_member_info, _query_member_contract_info as query_member_contract_info, factory_exports };